// src/components/common/LoadingButton.tsx
import React from 'react';
import '../../components/common/LoadingButton.css';

interface LoadingButtonProps {
  isLoading: boolean;
  onClick: () => void;
  children: React.ReactNode;
  disabled?: boolean; // Permite desabilitar o botão mesmo sem estar carregando
  className?: string; // Permite personalizar classes adicionais
}

const LoadingButton: React.FC<LoadingButtonProps> = ({
  isLoading,
  onClick,
  children,
  disabled = false,
  className = '',
}) => {
  return !isLoading ? (
    <button
      type="button"
      onClick={onClick}
      className={`loading-button ${className}`}
      disabled={disabled}
    >
      {children}
    </button>
  ) : (
    <button type="button" className={`loading-button clone ${className}`} disabled>
      <div className="spinner"></div>
    </button>
  );
};

export default LoadingButton;